window.SoHoArtworkReviewSources = {
  "01-the-transform.jpg": "https://cdn.shopify.com/s/files/1/1022/7223/7849/files/SoHoLife-REVIEW-Zoom-the-transform-master-20261023.png?v=1792782414",
  "02-honey-and-dyson.jpg": "https://cdn.shopify.com/s/files/1/1022/7223/7849/files/SoHoLife-REVIEW-Zoom-honey-and-dyson-master-20261023.png?v=1792782444",
  "03-blue-spades.jpg": "https://cdn.shopify.com/s/files/1/1022/7223/7849/files/SoHoLife-REVIEW-Zoom-blue-spades-master-20261023.png?v=1792782450",
  "04-think-create-grow-repeat.jpg": "https://cdn.shopify.com/s/files/1/1022/7223/7849/files/SoHoLife-REVIEW-Zoom-think-create-grow-repeat-master-20261023.png?v=1792782458",
  "05-she-leads.jpg": "https://cdn.shopify.com/s/files/1/1022/7223/7849/files/SoHoLife-REVIEW-Zoom-she-leads-master-20261023.png?v=1792782465",
  "07-black-girl-magic-activate.jpg": "https://cdn.shopify.com/s/files/1/1022/7223/7849/files/SoHoLife-REVIEW-Zoom-black-girl-magic-activate-master-20261023.png?v=1792782484",
  "08-every-play-matters.jpg": "https://cdn.shopify.com/s/files/1/1022/7223/7849/files/SoHoLife-REVIEW-Zoom-every-play-matters-master-20261023.png?v=1792782493",
  "09-my-style-has-substance.jpg": "https://cdn.shopify.com/s/files/1/1022/7223/7849/files/SoHoLife-REVIEW-Zoom-my-style-has-substance-master-20261023.png?v=1792782503",
  "11-let-the-good-times-roll.jpg": "https://cdn.shopify.com/s/files/1/1022/7223/7849/files/SoHoLife-REVIEW-Zoom-let-the-good-times-roll-master-20261023.png?v=1792782510",
  "12-survival-to-self.jpg": "https://cdn.shopify.com/s/files/1/1022/7223/7849/files/SoHoLife-REVIEW-Zoom-survival-to-self-master-20261023.png?v=1792782529",
  "13-butter-queen-bitter-queen.jpg": "https://cdn.shopify.com/s/files/1/1022/7223/7849/files/SoHoLife-REVIEW-Zoom-butter-queen-and-bitter-queen-master-20261023.png?v=1792782535",
  "14-old-fashioned-tee.jpg": "https://cdn.shopify.com/s/files/1/1022/7223/7849/files/SoHoLife-REVIEW-Zoom-old-fashioned-master-20261023.png?v=1792782543",
  "the-transform-approved-live-source.webp": "https://cdn.shopify.com/s/files/1/1022/7223/7849/files/SoHoLife-REVIEW-Zoom-the-transform-master-20261023.png?v=1792782414",
  "blue-spades-approved-live-source.webp": "https://cdn.shopify.com/s/files/1/1022/7223/7849/files/SoHoLife-REVIEW-Zoom-blue-spades-master-20261023.png?v=1792782450",
  "think-create-grow-repeat-approved-live-source.webp": "https://cdn.shopify.com/s/files/1/1022/7223/7849/files/SoHoLife-REVIEW-Zoom-think-create-grow-repeat-master-20261023.png?v=1792782458",
  "my-style-has-substance-approved-live-source.webp": "https://cdn.shopify.com/s/files/1/1022/7223/7849/files/SoHoLife-REVIEW-Zoom-my-style-has-substance-master-20261023.png?v=1792782503"
};
(() => {
  if (window.sohoDetailZoomLoaded) return;
  window.sohoDetailZoomLoaded = true;
  const sources = window.SoHoArtworkReviewSources || {};
  const pointer = matchMedia('(hover:hover) and (pointer:fine)');
  const surfaceSelector = '.sl-product-media, .sl-path-look-media, .product__media, .card__media .media';
  let dialog, viewport, canvas, label, message, counter, minus, plus, originalLink;
  let largeImage, opener, zoom = 1, fit = 1, maximumZoom = 1, request = 0;

  function sourceFor(image) {
    const raw = image.dataset.slDetailSource || image.getAttribute('src') || image.currentSrc;
    if (!raw) return '';
    try {
      const url = new URL(raw, location.href);
      const key = decodeURIComponent(url.pathname.split('/').pop()).toLowerCase();
      if (sources[key]) return sources[key];
      if (!/^https?:$/.test(url.protocol)) return '';
      if (url.hostname.endsWith('.shopify.com') || url.pathname.includes('/cdn/shop/')) {
        ['width', 'height', 'crop'].forEach(name => url.searchParams.delete(name));
      }
      return url.href;
    } catch (_) { return ''; }
  }

  function fitWidth(width, height, availableWidth, availableHeight) {
    const boxWidth = Math.max(1, Number(availableWidth) || 1);
    const boxHeight = Math.max(1, Number(availableHeight) || 1);
    return Math.max(1, Math.min(boxWidth, boxHeight * width / height, width));
  }

  function renderZoom(preservePosition = true) {
    if (!largeImage || !largeImage.naturalWidth) return;
    const oldWidth = parseFloat(largeImage.style.width) || fit;
    const oldHeight = oldWidth * largeImage.naturalHeight / largeImage.naturalWidth;
    const centerX = (viewport.scrollLeft + viewport.clientWidth / 2) / oldWidth;
    const centerY = (viewport.scrollTop + viewport.clientHeight / 2) / oldHeight;
    const width = Math.max(1, Math.min(largeImage.naturalWidth, fit * zoom));
    const height = width * largeImage.naturalHeight / largeImage.naturalWidth;
    largeImage.style.width = width + 'px';
    canvas.style.width = Math.max(viewport.clientWidth, width) + 'px';
    canvas.style.height = Math.max(viewport.clientHeight, height) + 'px';
    viewport.scrollLeft = preservePosition ? Math.max(0, centerX * width - viewport.clientWidth / 2) : 0;
    viewport.scrollTop = preservePosition ? Math.max(0, centerY * height - viewport.clientHeight / 2) : 0;
    counter.textContent = Math.round(zoom * 100) + '%';
    minus.disabled = zoom <= 1;
    plus.disabled = zoom >= maximumZoom - .001;
  }

  function fitImage() {
    if (!dialog.open || !largeImage || !largeImage.naturalWidth) return;
    const width = viewport.clientWidth || Math.max(1, Math.min(innerWidth * .96, 1500) - 24);
    const height = viewport.clientHeight || Math.max(1, innerHeight * .94 - 150);
    fit = fitWidth(largeImage.naturalWidth, largeImage.naturalHeight, width - 24, height - 24);
    maximumZoom = Math.max(1, Math.min(4, largeImage.naturalWidth / fit));
    zoom = Math.min(maximumZoom, Math.max(1, zoom));
    renderZoom(false);
  }

  function restorePage() {
    request += 1;
    document.documentElement.style.overflow = dialog.dataset.previousOverflow || '';
    if (opener && opener.isConnected) opener.focus({preventScroll: true});
  }

  function createDialog() {
    dialog = document.createElement('dialog');
    dialog.className = 'sl-detail-dialog';
    dialog.setAttribute('aria-label', 'Artwork detail viewer');
    dialog.innerHTML = '<div class="sl-detail-toolbar"><span class="sl-detail-title"></span><button type="button" data-action="minus" aria-label="Zoom out" disabled>−</button><output aria-live="polite">100%</output><button type="button" data-action="plus" aria-label="Zoom in" disabled>+</button><button type="button" data-action="fit">Fit image</button><a class="sl-detail-original" target="_blank" rel="noopener">Open full image</a><button type="button" data-action="close" aria-label="Close artwork viewer">Close ✕</button></div><p class="sl-detail-help">Use + to inspect the original image. Scroll or swipe to move around it.</p><div class="sl-detail-viewport"><p class="sl-detail-message" role="status">Loading artwork…</p><div class="sl-detail-canvas" hidden></div></div>';
    document.body.append(dialog);
    viewport = dialog.querySelector('.sl-detail-viewport');
    canvas = dialog.querySelector('.sl-detail-canvas');
    label = dialog.querySelector('.sl-detail-title');
    message = dialog.querySelector('.sl-detail-message');
    counter = dialog.querySelector('output');
    minus = dialog.querySelector('[data-action="minus"]');
    plus = dialog.querySelector('[data-action="plus"]');
    originalLink = dialog.querySelector('.sl-detail-original');
    dialog.addEventListener('click', event => {
      const action = event.target.closest('[data-action]')?.dataset.action;
      if (action === 'close') dialog.close();
      if (action === 'plus') { zoom = Math.min(maximumZoom, zoom + .5); renderZoom(); }
      if (action === 'minus') { zoom = Math.max(1, zoom - .5); renderZoom(); }
      if (action === 'fit') { zoom = 1; fitImage(); }
      if (event.target === dialog) {
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      }
    });
    dialog.addEventListener('close', restorePage);
    window.addEventListener('resize', fitImage);
  }

  function openImage(image, control) {
    if (!dialog) createDialog();
    const source = sourceFor(image);
    const token = ++request;
    opener = control;
    zoom = 1;
    largeImage = null;
    label.textContent = image.alt || 'Artwork details';
    counter.textContent = '100%';
    minus.disabled = plus.disabled = true;
    canvas.hidden = true;
    canvas.replaceChildren();
    canvas.style.width = canvas.style.height = '';
    message.hidden = false;
    message.textContent = source ? 'Loading artwork…' : 'This image is unavailable. Please close the viewer and try another image.';
    originalLink.hidden = !source;
    if (source) originalLink.href = source;
    if (!dialog.open) {
      dialog.dataset.previousOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      dialog.showModal();
    }
    dialog.querySelector('[data-action="close"]').focus();
    if (!source) return;
    const loaded = new Image();
    loaded.alt = image.alt || 'Enlarged artwork';
    loaded.className = 'sl-detail-image';
    loaded.decoding = 'async';
    let completed = false;
    const showLoaded = () => {
      if (completed || token !== request || !dialog.open || !loaded.naturalWidth) return;
      completed = true;
      largeImage = loaded;
      canvas.replaceChildren(loaded);
      canvas.hidden = false;
      message.hidden = true;
      fitImage();
      requestAnimationFrame(() => { if (token === request) fitImage(); });
    };
    loaded.onload = showLoaded;
    loaded.onerror = () => {
      if (token !== request || !dialog.open) return;
      message.textContent = 'The artwork could not be loaded. Use “Open full image” above, or close the viewer and try again.';
      message.hidden = false;
      canvas.hidden = true;
    };
    loaded.src = source;
    if (loaded.complete && loaded.naturalWidth) showLoaded();
  }

  function upgrade(image) {
    const source = sourceFor(image);
    if (!source || image.dataset.slUpgradePending === source || image.dataset.slUpgradeComplete === source) return;
    const sourceKey = decodeURIComponent((image.getAttribute('src') || '').split('?')[0].split('/').pop()).toLowerCase();
    const isBoardMaster = Boolean(sources[sourceKey]);
    image.dataset.slDetailSource = source;
    image.dataset.slUpgradePending = source;
    const full = new Image();
    full.onload = () => {
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = source;
      image.width = full.naturalWidth;
      image.height = full.naturalHeight;
      image.dataset.slUpgradeComplete = source;
      delete image.dataset.slUpgradePending;
      if (isBoardMaster) {
        image.dataset.slBoardMaster = 'true';
        image.closest(surfaceSelector)?.classList.remove('sl-catalogue-page', 'sl-catalogue-page--transform');
      }
    };
    full.onerror = () => { delete image.dataset.slUpgradePending; };
    full.src = source;
  }

  function enhance(root = document) {
    root.querySelectorAll(surfaceSelector).forEach(surface => {
      const image = surface.querySelector('img');
      if (!image || surface.dataset.slDetailReady) return;
      surface.dataset.slDetailReady = 'true';
      surface.classList.add('sl-detail-zoom-surface');
      if (surface.matches('.sl-path-look-media') && /(?:Think-Create-Grow-Repeat|Blue-Spades|My-Style-Has-Substance|The-Transform)-approved-live-source/.test(image.src)) {
        surface.classList.add('sl-catalogue-page');
        if (/The-Transform-approved-live-source/.test(image.src)) surface.classList.add('sl-catalogue-page--transform');
      }
      let bounds;
      surface.addEventListener('pointerenter', () => {
        surface.classList.remove('sl-detail-zoom-active');
        const r = image.getBoundingClientRect();
        bounds = {left:r.left + scrollX, top:r.top + scrollY, width:r.width, height:r.height};
        upgrade(image);
      });
      surface.addEventListener('pointermove', event => {
        if (!pointer.matches || event.pointerType === 'touch' || !bounds || !bounds.width || !bounds.height) return;
        const density = Math.max(1, devicePixelRatio || 1);
        const scale = Math.max(1, Math.min(3, image.naturalWidth / (bounds.width * density)));
        surface.style.setProperty('--sl-zoom-scale', scale);
        surface.style.setProperty('--sl-zoom-x', Math.max(0,Math.min(100,(event.clientX + scrollX - bounds.left)/bounds.width*100))+'%');
        surface.style.setProperty('--sl-zoom-y', Math.max(0,Math.min(100,(event.clientY + scrollY - bounds.top)/bounds.height*100))+'%');
        surface.classList.add('sl-detail-zoom-active');
      });
      ['pointerleave','pointercancel'].forEach(name => surface.addEventListener(name, () => surface.classList.remove('sl-detail-zoom-active')));
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'sl-detail-zoom-button';
      button.textContent = '⊕ Enlarge';
      button.setAttribute('aria-label', 'Enlarge ' + (image.alt || 'artwork'));
      button.setAttribute('aria-haspopup','dialog');
      button.slDetailImage = image;
      const host = surface.closest('a') ? surface.parentElement : surface;
      if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
      if (host !== surface) { button.style.top = (surface.offsetTop + 8) + 'px'; button.style.bottom = 'auto'; }
      host.append(button);
      // Load mapped board masters without replacing any live product media.
      const key = decodeURIComponent((image.getAttribute('src') || '').split('?')[0].split('/').pop()).toLowerCase();
      if (sources[key]) upgrade(image);
    });
  }

  // The artwork and both magnifying-glass controls share one viewer.
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element) || event.target.closest('.sl-detail-dialog')) return;
    const control = event.target.closest('.sl-detail-zoom-button, .product__media-toggle');
    let image = control?.slDetailImage || control?.closest('.product__modal-opener')?.querySelector('.product__media img');
    if (!image) image = event.target.closest(surfaceSelector)?.querySelector('img');
    if (!image) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    image.closest(surfaceSelector)?.classList.remove('sl-detail-zoom-active');
    openImage(image, control || event.target.closest('a,button') || image);
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => enhance());
  else enhance();
  document.addEventListener('shopify:section:load', event => enhance(event.target));
  const main = document.querySelector('main');
  if (main) new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && !node.classList.contains('sl-detail-zoom-button')))) enhance(main);
  }).observe(main,{childList:true,subtree:true});
})();
